// @flow
import actionTypes from './actionTypes';

export function saveScrollLatestPosition(scrollX: number, scrollY: number): TrovitAction {
  return {
    type: actionTypes.SAVE_SCROLL_LATEST_POSITION,
    payload: {
      scrollX,
      scrollY,
    },
  };
}

export function updateWindowScrollPosition(): TrovitAction {
  return {
    type: actionTypes.UPDATE_WINDOW_SCROLL_POSITION,
  };
}



// WEBPACK FOOTER //
// ./app/UI/scroll/actions.js